import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Icon } from 'react-materialize';
import { formatNumber } from '../../helpers';
import * as actions from '../../actions';
import './style.css';

class PageDataTable extends Component {
  constructor(props) {
    super(props);
    this.handleOnClick = this.handleOnClick.bind(this);
    this.renderIcon    = this.renderIcon.bind(this);
  }

  // shouldComponentUpdate(nextProps) {
  //   const diffActive         = nextProps.isPageActive           !== this.props.isPageActive;
  //   const diffPageLoading    = nextProps.pageLoading        !== this.props.pageLoading;
  //   const diffSearchQuery    = nextProps.searchQuery        !== this.props.searchQuery;
  //   const diffPageNum        = nextProps.activePageNum      !== this.props.activePageNum;
  //   const diffSortOrder      = nextProps.pageOrderDirection !== this.props.pageOrderDirection;
  //   const diffPageSortMetric = nextProps.pageSortMetric     !== this.props.pageSortMetric;

  //   const componentShouldUpdate =
  //     diffActive      ||
  //     diffPageLoading ||
  //     diffSearchQuery ||
  //     diffPageNum     ||
  //     diffSortOrder   ||
  //     diffPageSortMetric;

  //   return componentShouldUpdate;
  // }

  componentWillReceiveProps(nextProps) {
    const {
      startDate,
      endDate,
      country,
      device,
      auth,
      pageSortMetric,
      selectedSite
    } = nextProps;

    const { fetchPages, setPageOrderDirection, selectPage } = this.props;

    const diffEndDate        = this.props.endDate      !== endDate;
    const diffStartDate      = this.props.startDate    !== startDate;
    const diffCountry        = this.props.country      !== country;
    const diffDevice         = this.props.device       !== device;
    const diffAuth           = auth                    !== this.props.auth;
    const diffPageSortMetric = pageSortMetric          !== this.props.pageSortMetric;
    const diffSite           = this.props.selectedSite !== selectedSite;

    // Don't run if dates are invalid i.e. endDate is before startDate
    if (endDate < startDate) {
      return;
    }

    const noDateChange =
      !startDate            ||
      !endDate              ||
      !this.props.startDate ||
      !this.props.endDate;

    const dimensionChange =
      diffStartDate ||
      diffEndDate   ||
      diffCountry   ||
      diffDevice    ||
      diffAuth;

    if (noDateChange) return;
    const firstPageTableLoad = this.props.pages.length === 0 && nextProps.pages.length > 0;
    if (firstPageTableLoad) {
      const sitePage = nextProps.pages[0]['keys'][0];
      this.props.selectPage(sitePage);
      this.props.checkPageActive(sitePage);
    }

    if (dimensionChange) {
      fetchPages({ startDate, endDate, country, device });
    }

    if (diffSite) {
      fetchPages();
      selectPage();
    }

    if (diffPageSortMetric) {
      setPageOrderDirection();
    }
  }

  renderRows() {
    const {
      pages,
      isPageActive,
      selectPage,
      checkPageActive,
      fetchQueryMetricsByDate,
      activePageNum,
      pagesSearch,
      selectedPage,
      checkQueryActive,
      fetchKeywordDensity,
      fetchPageMeta,
      selectQuery
    } = this.props;

    const endNum = activePageNum * 10;
    const startNum = endNum - 10;

    const sortedData = ((pagesSearch, pages) => {
      if (pagesSearch.length > 0) return this.sortData(pagesSearch)
      else if (!pagesSearch)      return [];
      else                        return this.sortData(pages)
    })(pagesSearch, pages);

    if (!pagesSearch) {
      return (
        <tr>
          <td>No pages found with your search. Clear the searchbar or try again.</td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      );
    }

    return sortedData.slice(startNum, endNum).map(page => {
      const sitePage = page.keys[0];
      const ctr = (page.ctr * 100).toFixed(2);

      return (
        <tr
          className={isPageActive === sitePage ? 'tableActive' : null}
          key={sitePage}
          onClick={() => {
            checkQueryActive();
            selectQuery();
            fetchQueryMetricsByDate();
            fetchKeywordDensity();

            if (selectedPage === sitePage) {
              selectPage();
              checkPageActive();
              fetchPageMeta();
              return;
            }

            selectPage(sitePage);
            checkPageActive(sitePage);
          }}
        >
          <td>{sitePage}</td>
          <td>{formatNumber(page.clicks)}</td>
          <td>{formatNumber(page.impressions)}</td>
          <td>{ctr}%</td>
        </tr>
      );
    });
  }

  sortData(pageDataRows) {
    const { pageSortMetric, pageOrderDirection } = this.props;

    if (pageOrderDirection === 'DESC') {
      return pageDataRows.sort(function(a, b) {
        if (pageSortMetric === 'keys') {
          const pageA = a[pageSortMetric][0];
          const pageB = b[pageSortMetric][0];

          if (pageA > pageB) {
            return -1;
          }

          if (pageA < pageB) {
            return 1;
          }

          return 0;
        } else {
          return b[pageSortMetric] - a[pageSortMetric];
        }
      });
    }

    if (pageOrderDirection === 'ASC') {
      return pageDataRows.sort(function(a, b) {
        if (pageSortMetric === 'keys') {
          const pageA = a[pageSortMetric][0];
          const pageB = b[pageSortMetric][0];

          if (pageA < pageB) {
            return -1;
          }

          if (pageA > pageB) {
            return 1;
          }

          return 0;
        } else {
          return a[pageSortMetric] - b[pageSortMetric];
        }
      });
    }

    return pageDataRows;
  }

  handleOnClick(event) {
    const metricToSort = event.target.getAttribute('value');
    this.props.setPageSortMetric(metricToSort);
    this.props.setPageOrderDirection(this.props.pageOrderDirection);
  }

  renderIcon(value) {
    const { pageSortMetric, pageOrderDirection } = this.props;
    if (pageSortMetric === value && pageOrderDirection === 'DESC') {
      return <Icon className="disable-select">keyboard_arrow_down</Icon>;
    } else if (pageSortMetric === value && pageOrderDirection === 'ASC') {
      return <Icon className="disable-select">keyboard_arrow_up</Icon>;
    }
  }

  render() {
    return (
      <Table hoverable={true} responsive={true}>
        <thead>
          <tr>
            <th value="keys" onClick={this.handleOnClick}>
              <span value="keys" className="filter-header">
                Page {this.renderIcon('keys')}
              </span>
            </th>
            <th value="clicks" onClick={this.handleOnClick}>
              <span value="clicks" className="filter-header">
                Clicks {this.renderIcon('clicks')}
              </span>
            </th>
            <th value="impressions" onClick={this.handleOnClick}>
              <span value="impressions" className="filter-header">
                Impressions {this.renderIcon('impressions')}
              </span>
            </th>
            <th value="ctr" onClick={this.handleOnClick}>
              <span value="ctr" className="filter-header">
                CTR {this.renderIcon('ctr')}
              </span>
            </th>
          </tr>
        </thead>
        <tbody>{this.renderRows()}</tbody>
      </Table>
    );
  }
}

function mapStateToProps({
  pages,
  pagesSearch,
  startDate,
  endDate,
  isPageActive,
  selectedMetric,
  selectedPage,
  pageLoading,
  country,
  auth,
  activePageNum,
  device,
  selectedSite,
  pageSortMetric,
  searchQuery,
  selectedQuery,
  pageOrderDirection
}) {
  return {
    pages,
    pagesSearch,
    startDate,
    endDate,
    isPageActive,
    selectedMetric,
    selectedPage,
    pageLoading,
    country,
    auth,
    activePageNum,
    device,
    selectedSite,
    pageSortMetric,
    searchQuery,
    selectedQuery,
    pageOrderDirection
  };
}

export default connect(mapStateToProps, actions)(PageDataTable);



// WEBPACK FOOTER //
// ./src/components/Dashboard/PageDataTable.js